import Vue from 'vue';
import VueRouter from 'vue-router';
import auth from '../middleware/auth';
import Login from '../components/home/Login.vue';
import NewPassword from '../components/home/NewPassword.vue';
import ValidUser from '../components/home/ValidUser.vue';
import ForgetPassword from '../components/home/ForgetPassword.vue';
import Register from '../components/home/Register.vue';
import UserProfileRegister from '../components/home/UserProfileRegister.vue';
import Home from '../views/Home.vue';
import Foyer from '../views/Foyer.vue';
import FoyerLevels from '../views/FoyerLevels.vue';
import FoyerCategory from '../views/FoyerCategory.vue';
import Foyer2D from '../views/Foyer2D.vue';
import Iframe from '../views/Iframe.vue';
import Now from '../views/Now.vue';
import Live from '../views/Live.vue';
import Conference from '../views/Conference.vue';
import Network from '../views/Network.vue';
import Schedule from '../views/Schedule.vue';
import PhotoBooth from '../views/PhotoBooth.vue';
import AudioRecorder from '../views/AudioRecorder.vue';
import Areas from '../views/Areas.vue';
import UserProfile from '../views/UserProfile.vue';
import ActivityList from '../views/ActivityList.vue';
import ActivityImage from '../views/ActivityImage.vue';
import VideoGallery from '../views/VideoGallery.vue';
import LandingPage from '../views/LandingPage.vue';
import Trails from '../views/Trails.vue';
import SlotMachine from '../views/SlotMachine.vue';
import Roullete from '../views/Roullete.vue';
import Level from '../views/Level.vue';
import Cracha from '../views/Cracha.vue';
import Cart from '../views/Cart.vue';
import PersonalSchedule from '../views/PersonalSchedule.vue';
import Contacts from '../views/Contacts.vue';
import Tickets from '../views/Tickets.vue';
import GamerProfile from '../views/GamerProfile.vue';
import ErrorPage from '../views/Error.vue';
import Signature from '../views/Signature.vue';
import Meta from '../views/Meta.vue';
import DynamicMeetings from '../views/DynamicMeetings.vue';
import Interactions from '../views/Interactions.vue';
import LoginExt from '../components/home/LoginExt.vue';
// import LoginMeet from '../components/home/LoginMeet.vue';
import CheckAccessFanCam from '../components/home/CheckAccessFanCam.vue';
import QRCodeView from '../views/QRCodeView.vue';
import CheckPointView from '../views/CheckPointView.vue';

import store from '../store/index';

import LoginRegister from '../components/home/LoginRegister.vue';

// import ChatGPTView from '../views/ChatGPTView.vue';
import ArtAIView from '../views/ArtAIView.vue';

const MultiGallery = () => import('../views/MultiGallery.vue');
const Products = () => import('../views/Products.vue');
const Timeline = () => import('../views/Timeline.vue');
const Certificates = () => import('../views/Certificates.vue');
const UserGallery = () => import('../views/UserGallery.vue');
const Shopping = () => import('../views/Shopping.vue');
const Transaction = () => import('../views/Transaction.vue');
const TransactionCoins = () => import('../views/TransactionCoins.vue');
const FindMeHere = () => import('../views/FindMeHere.vue');
const Hosted = () => import('../views/Hosted.vue');
const HostedAudio = () => import('../views/HostedAudio.vue');
const TrailProducts = () => import('../views/TrailProducts.vue');

const UserInfoView = () => import('../views/UserInfoView.vue');
const Dashboard = () => import('../views/Dashboard.vue');

const QueueManager = () => import('../views/queues/QueueManager.vue');
const QueueUser = () => import('../views/queues/QueueUser.vue');

const SupportManager = () => import('../views/SupportManager.vue');

const LogisticsManager = () => import('../views/LogisticsManager.vue');
const Logistics = () => import('../views/LogisticsUser.vue');
const LogisticsRegister = () => import('../views/LogisticsRegister.vue');
// const UnicoTest = () => import('../views/UnicoTest.vue');

const Explorer = () => import('../views/Explorer.vue');

const Odds = () => import('../views/Odds.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/Timeline/:stream/',
    name: 'Timeline',
    component: Timeline,
  },
  {
    path: '/odds/:stream?',
    name: 'Odds',
    component: Odds,
  },
  {
    path: '/explorer/:stream?',
    name: 'Explorer',
    component: Explorer,
  },
  {
    path: '/logisticsregister/:stream?',
    name: 'LogisticsRegister',
    component: LogisticsRegister,
  },
  {
    path: '/logisticsmanager/:stream?',
    name: 'LogisticsManager',
    component: LogisticsManager,
  },
  {
    path: '/logistics',
    name: 'Logistics',
    component: Logistics,
  },
  {
    path: '/logistics/:stream',
    name: 'LogisticsWithStream',
    component: Logistics,
  },
  {
    path: '/dashboard/',
    name: 'Dashboard',
    component: Dashboard,
  },

  {
    path: '/supportmanager/',
    name: 'SupportManager',
    component: SupportManager,
  },
  {
    path: '/QueueUser/:stream?',
    name: 'QueueUser',
    component: QueueUser,
  },
  {
    path: '/QueueManager/:stream?',
    name: 'QueueManager',
    component: QueueManager,
  },
  {
    path: '/trailProducts/:stream',
    name: 'TrailProducts',
    component: TrailProducts,
  },
  {
    path: '/hosted',
    name: 'Hosted',
    component: Hosted,
  },
  {
    path: '/hostedAudio',
    name: 'HostedAudio',
    component: HostedAudio,
  },
  {
    path: '/findmehere',
    name: 'FindMeHere',
    component: FindMeHere,
  },
  {
    path: '/Transaction/:order_id?',
    name: 'Transaction',
    component: Transaction,
  },
  {
    path: '/TransactionCoins/:order_id?',
    name: 'TransactionCoins',
    component: TransactionCoins,
  },
  {
    path: '/Shopping/:stream?',
    name: 'Shopping',
    component: Shopping,
  },
  {
    path: '/DynamicMeetings/:stream?',
    name: 'DynamicMeetings',
    component: DynamicMeetings,
  },
  {
    path: '/Meta/:stream?',
    name: 'Meta',
    component: Meta,
  },
  {
    path: '/Signature/:stream',
    name: 'Signature',
    component: Signature,
  },
  {
    path: '/Certificates',
    name: 'Certificates',
    component: Certificates,
  },
  {
    path: '/Error',
    name: 'Error',
    component: ErrorPage,
  },
  {
    path: '/GamerProfile',
    name: 'GamerProfile',
    component: GamerProfile,
  },
  {
    path: '/Tickets',
    name: 'Tickets',
    component: Tickets,
  },
  {
    path: '/SlotMachine/:stream',
    name: 'SlotMachine',
    component: SlotMachine,
  },
  {
    path: '/Roullete/:stream',
    name: 'Roullete',
    component: Roullete,
  },
  {
    path: '/login',
    name: 'Login',
    component: store.state.template.useUnifiedLoginRegister == false ? Login : LoginRegister,
  },
  {
    path: '/level',
    name: 'Level',
    component: Level,
  },
  {
    path: '/Trails/:stream',
    name: 'Trails',
    component: Trails,
  },
  {
    path: '/LandingPage',
    name: 'LandingPage',
    component: LandingPage,
  },
  {
    path: '/createNewPassword/:token',
    name: 'NewPassword',
    component: LoginRegister,
  },
  {
    path: '/valid/:email?/:token?',
    name: 'ValidUser',
    component: ValidUser,
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: {
      middleware: [
        // auth
      ],
    },
  },
  {
    path: '/Register/:preview?',
    name: 'Register',
    component: store.state.template.useUnifiedLoginRegister ? LoginRegister : Register,
    meta: {
      middleware: [
        // auth
      ],
    },
  },
  {
    path: '/UserProfileRegister',
    name: 'UserProfileRegister',
    component: UserProfileRegister,
    meta: {
      middleware: [
        // auth
      ],
    },
  },
  {
    path: '/ArtAI',
    name: 'ArtAIView',
    component: ArtAIView,
    meta: {
      middleware: [
        // auth
      ],
    },
  },
  // {
  //   path: '/unicoCamera',
  //   name: 'UnicoTest',
  //   component: UnicoTest,
  //   meta: {
  //     middleware: [
  //       // auth
  //     ],
  //   },
  // },
  // {
  //   path: '/ChatGPT',
  //   name: 'ChatGPTView',
  //   component: ChatGPTView,
  //   meta: {
  //     middleware: [
  //       // auth
  //     ],
  //   },
  // },
  {
    path: '/',
    name: 'Home',
    alias: '/home',
    component: Home,
    meta: {
      middleware: [],
    },
  },
  {
    path: '/foyer/:stream',
    name: 'Foyer',
    component: Foyer,
  },
  {
    path: '/foyerlevels/:stream',
    name: 'FoyerLevels',
    component: FoyerLevels,
  },
  {
    path: '/iframe/:stream',
    name: 'Iframe',
    component: Iframe,
  },
  {
    path: '/live/:stream',
    name: 'Live',
    component: Live,
  },
  {
    path: '/userprofile',
    name: 'UserProfile',
    component: UserProfile,
  },
  {
    path: '/qrcode',
    name: 'QRCodeView',
    component: QRCodeView,
  },
  {
    path: '/userInfo/:stream',
    name: 'UserInfoView',
    component: UserInfoView,
  },
  {
    path: '/personalschedule',
    name: 'PersonalSchedule',
    component: PersonalSchedule,
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts,
  },
  {
    path: '/Cracha',
    name: 'Cracha',
    component: Cracha,
  },
  {
    path: '/Conference/:stream?',
    name: 'Conference',
    component: Conference,
  },
  {
    path: '/foyerCategory/:stream',
    name: 'FoyerCategory',
    component: FoyerCategory,
  },
  {
    path: '/foyer2D/:stream/:standFromLink?',
    name: 'Foyer2D',
    component: Foyer2D,
    props: true,
  },
  {
    path: '/areas/:stream/:standFromLink?',
    name: 'Areas',
    component: Areas,
    props: true,
  },
  {
    path: '/VideoGallery/:stream',
    name: 'VideoGallery',
    component: VideoGallery,
  },
  {
    path: '/MultiGallery/:stream',
    name: 'MultiGallery',
    component: MultiGallery,
  },
  {
    path: '/Products/:stream',
    name: 'Products',
    component: Products,
  },
  {
    path: '/network/:stream',
    name: 'Network',
    component: Network,
  },
  {
    path: '/schedule/:date_start?',
    name: 'Schedule',
    component: Schedule,
  },
  {
    path: '/now',
    name: 'Now',
    component: Now,
    meta: {
      middleware: [
        // auth
      ],
    },
  },
  {
    path: '/photobooth/:stream',
    name: 'PhotoBooth',
    component: PhotoBooth,
  },
  {
    path: '/audiorecorder/:stream',
    name: 'AudioRecorder',
    component: AudioRecorder,
  },
  {
    path: '/plenarias',
    name: 'ActivityList',
    component: ActivityList,
  },
  {
    path: '/ActivityImage/:stream',
    name: 'ActivityImage',
    component: ActivityImage,
  },
  // {
  //   path: '/access/:stream',
  //   name: 'Access',
  //   component: LoginMeet
  // },
  {
    path: '/back/:stream',
    name: 'Back',
    component: Login,
  },
  //  {
  //    path: '/back',
  //    name: 'Back Destin',
  //    component: Login
  //  },
  {
    path: '/checkAccess/:stream',
    name: 'CheckAccessFanCam',
    component: CheckAccessFanCam,
  },
  {
    path: '/interactions/:stream',
    name: 'Interactions',
    component: Interactions,
  },
  {
    path: '/loginext',
    name: 'LoginExt',
    component: LoginExt,
  },
  {
    path: '/CheckPoint/:stream',
    name: 'CheckPoint',
    component: CheckPointView,
  },
  {
    path: '/usergallery',
    name: 'UserGallery',
    component: UserGallery,
  },
];

const router = new VueRouter({
  routes,
});

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  //console.log('Route', to, from, next);
  try{
    if (to.name == 'Home' && store.state.template.accessConfig.registerFirst) {
        //console.log('Go Register');
        // next({ name: 'Register' });
        router.push({ name: 'Register' });
      } else if (
        to.name !== 'Home' &&
        to.name !== 'ForgetPassword' &&
        to.name !== 'Login' &&
        to.name !== 'LoginExt' &&
        to.name !== 'Register' &&
        to.name !== 'NewPassword' &&
        to.name !== 'ValidUser' &&
        to.name !== 'LandingPage' &&
        to.name !== 'Tickets' &&
        to.name !== 'Access' &&
        to.name !== 'CheckAccessFanCam' &&
        to.name !== 'Back' &&
        to.name !== 'Signature' &&
        to.name !== 'Interactions' &&
        to.name !== 'UserInfoView' &&
        to.name !== 'FindMeHere' &&
        to.name !== 'Hosted' &&
        to.name !== 'HostedAudio' &&
        !auth() &&
        store.state.template.accessConfig.accessControl
      ){
        //console.log('Next Home');
        // next({ name: 'Home' });
        router.push({ name: 'Home', params: {to} });
      }else{ 
        //console.log('Go Next');
        next();
      }
  }catch(err){
    //console.log('Erro route:',err);        
    router.push({ name: 'Home' , params: {to}});
  }
 
});

export default router;
